import axios, { CancelTokenSource } from "axios"

export function getNewCancelTokenSource (
	cancelTokenSource: CancelTokenSource | undefined = undefined,
	cancelExistingTokenSource: boolean = false,
	cancelMessage: string | undefined = undefined
): CancelTokenSource {
	if (cancelTokenSource && cancelExistingTokenSource) {
		cancelTokenSource.cancel(cancelMessage)
	}

	return axios.CancelToken.source()
}
